function ToolHintOverlay({ hint }) {
  if (!hint) return null

  return (
    <div className="absolute bottom-20 left-1/2 -translate-x-1/2 bg-black/75 text-white text-xs sm:text-sm px-3 py-2 rounded-lg max-w-xs text-center pointer-events-none">
      {hint}
    </div>
  )
}

export default ToolHintOverlay
